import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_HUMIDITY_GRAPH } from './url-constants';

type HumidityGraphEndpointSpecification = ApiEndpointSpecification;
export const HumidityGraphEndpointSpecification: HumidityGraphEndpointSpecification = {
    url: DEVICE_HUMIDITY_GRAPH,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'HumidityGraphRequestParams',
    requestBodySchemaName: 'HumidityGraphRequestBody',
    okResponseSchemaName: 'HumidityGraphOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2,
};

export const invokeHumidityGraphData = Helpers.makeApiRequestFn<
    Types.HumidityGraphRequestParams,
    Types.HumidityGraphRequestBody,
    Types.HumidityGraphOkresponse
>(HumidityGraphEndpointSpecification);
